import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import TelegramIcon from "../../assets/icon/svgs/Telegram.svg?react";
import { useTranslation } from "react-i18next";

export function PopUpLinkTelegram({
  openPopUp,
  telegramLink,
  onClose,
  setTelegramToggle,
}: {
  openPopUp: boolean;
  telegramLink: string | undefined;
  onClose: () => void;
  setTelegramToggle: () => void;
}) {
  const { t } = useTranslation();

  const openTelegramLink = () => {
    window.open(telegramLink, "_blank");
  };

  return (
    <Dialog open={openPopUp} onOpenChange={onClose} modal={false}>
      {openPopUp && (
        <div className="fixed inset-0 bg-black/10 backdrop-blur-[4px] z-40 pointer-events-none"></div>
      )}
      <DialogContent className="max-h-full overflow-auto w-[590px] pb-[40px]">
        <DialogHeader className="mb-[16px] flex-call gap-4">
          <div className="flex flex-row gap-4">
            <TelegramIcon
              width={32}
              height={32}
              className="text-[#0027CB] whitespace-nowrap shrink-0"
            />
            <div className="flex flex-col gap-2">
              <DialogTitle className="text-[24px] text-left font-medium leading-[130%] !m-0">
                {t("popUpLinkTelegram.header")}
              </DialogTitle>
              <DialogDescription className="text-[16px] !m-0 leading-[130%] text-left font-medium text-[#000000]">
                {t("popUpLinkTelegram.description")}
              </DialogDescription>
              <DialogDescription className="text-[16px] !m-0 leading-[130%] text-left font-medium text-[#00000080]">
                {t("popUpLinkTelegram.description2")}
              </DialogDescription>
            </div>
          </div>
        </DialogHeader>

        <Button
          type="submit"
          variant="system"
          size="system"
          disabled={false}
          loading={false}
          onClick={() => {
            openTelegramLink();
            setTelegramToggle();
            onClose();
          }}
        >
          {t("popUpLinkTelegram.go_to_telegram")}
        </Button>
      </DialogContent>
    </Dialog>
  );
}
